export default {
  int: /^([1-9]([0-9]+)?)?$/,
  number: /^([1-9]([0-9]+)?|0)(\.\d)?$/,
  price: /^([1-9]([0-9]+)?|0)(\.\d{1,4})?$/,
  money: /^([1-9]([0-9]+)?|0)(\.\d{1,2})?$/,
  qty: /^([1-9]([0-9]+)?|0)(\.\d{1,4})?$/
}



// WEBPACK FOOTER //
// ./src/utils/reg.js